import JSXComponent from "../../dist/jsx-render/JSXComponent";
import dom from "../../dist/jsx-render/dom";
import { app } from "../Frame/App";

export type PopupCustomButton = {
    text: string;
    action: (event: Event) => void;
    cssClasses?: string;
}

export type DynPopupProps = {

    // Buttons
    showSaveButton?: boolean;
    showDeleteButton?: boolean;
    labelSaveButton?: string;
    labelOkButton?: string;
    showOkButton?: boolean;
    showCancelButton?: boolean;
    labelCancelButton?: string;
    labelDeleteButton?: string;
    showCloseButton?: boolean;
    customButtons?: PopupCustomButton[];

    /** uses flex on the popup-body and centers the content */
    centerContent?: boolean;

    // Appearance
    showFooter?: boolean;
    size?: "fullscreen" | "standard" | "small" | "medium" | "dialog" | "fit" | "widgetdialog" | "large";
    title?: string;
    width?: string;
    height?: string;
    zIndex?: number;

    /** The popup's child elements. Can be either set directly or displays the children of the JSX <DynPopup> Tags. */
    children?: any;

    /** Elements that are shown in the popup's footer. */
    footer?: any;

    // Events
    onShown?: () => void;
    onSave?: (event: Event) => boolean;
    onOk?: (event: Event) => void;
    onCancel?: (event: Event) => void;
    onDelete?: (event: Event) => boolean;
    onClose?: () => void;
    onClosed?: () => void;

    /** If set to true, all controls except the close and cancel button are disabled. */
    disabled?: boolean;

    cssClass?: string;
}

export class DynPopup extends JSXComponent {
    private zIndex: number;

    props: DynPopupProps;
    constructor(props: DynPopupProps) {
        super(props);
    }

    getCloseButton = () => {
        let closeButton: HTMLButtonElement = <button type="button" className="close" aria-label="Close">
            <span aria-hidden="true">×</span>
        </button>;
        closeButton.addEventListener("click", this.onClose);
        return closeButton;
    }

    getButtons = (): HTMLElement[] => {
        let buttons: HTMLElement[] = [];

        if (this.props.customButtons && this.props.customButtons.length > 0) {
            for (let buttonDef of this.props.customButtons) {
                let button: HTMLButtonElement = <button
                    type="button" className={`btn ${(buttonDef.cssClasses ? ` ${buttonDef.cssClasses} ` : "")} btn-mso`}
                    aria-label={buttonDef.text}>
                    {buttonDef.text}
                </button>;
                button.addEventListener("click", buttonDef.action);

                buttons.push(button);
            }
        }

        if (this.props.showDeleteButton) {
            let button: HTMLButtonElement =
                <button type="button"
                    class="btn btn-delete btn-mso"
                    aria-label={Resources.Common.delete}>
                    {this.props.labelDeleteButton
                        ?? Resources.Common.delete}
                </button>;
            button.addEventListener("click", this.onDelete);
            buttons.push(button);
        }

        if (this.props.showCancelButton) {
            let button: HTMLButtonElement =
                <button type="button"
                    class="btn btn-cancel btn-mso"
                    aria-label={Resources.Common.cancel}>
                    {this.props.labelCancelButton
                        ?? Resources.Common.cancel}
                </button>;
            button.addEventListener("click", this.onCancel);
            buttons.push(button);
        }

        if (this.props.showOkButton) {
            let button: HTMLButtonElement =
                <button type="button" class="btn btn-save btn-mso"
                    aria-label={this.props.labelOkButton
                        ? this.props.labelOkButton
                        : Resources.Common.ok}>
                    {this.props.labelOkButton
                        ? this.props.labelOkButton
                        : Resources.Common.ok}
                </button >;
            button.addEventListener("click", this.onOk);
            buttons.push(button);
        }

        if (this.props.showSaveButton) {
            let button: HTMLButtonElement =
                <button type="button" class="btn btn-save btn-mso"
                    aria-label={this.props.labelSaveButton
                        ? this.props.labelSaveButton
                        : Resources.Common.saveAndClose}>
                    {this.props.labelSaveButton
                        ? this.props.labelSaveButton
                        : Resources.Common.saveAndClose}
                </button>;
            button.addEventListener("click", this.onSave);
            buttons.push(button);
        }

        return buttons;
    }

    createFooter = () => {
        let buttons = this.getButtons();

        let footer = <div className="popup-footer modal-footer">
            {...this.props.footer}
            {...buttons}
        </div>

        return footer;
    }

    element: HTMLDivElement;
    getElement = () => {
        let element = <div className={`popup-background ${this.props.cssClass}`} style={{ "z-index": this.zIndex }}>
            <div className={`popup-frame${(this.props.size ? ` popup-${this.props.size}` : "")}`} style={this.props.width ? { "max-width": this.props.width } : ""} >
                <div className="popup-content" >
                    <div className="popup-header">
                        <div id="_popupTitle" className="popup-title">{this.props.title}</div>
                        {this.props.showCloseButton === false
                            ? []
                            : this.getCloseButton()}
                    </div>
                    <div className="popup-body" style={(this.props.centerContent ? { "display": "flex", "justify-content": "center", "align-items": "center" } : "")}>
                        {...this.props.children}
                    </div>
                    {!this.props.showFooter === true
                        ? []
                        : this.createFooter()
                    }
                </div>
            </div>
        </div>;

        return element;
    }

    render() {

        if (!this.props.size || this.props.size.length == 0) {
            this.props.size = "standard";
        }

        if (this.props.showCancelButton
            || this.props.showCloseButton
            || this.props.showOkButton
            || this.props.showSaveButton
            || this.props.customButtons) {
            this.props.showFooter = true;
        }

        this.element = this.getElement();

        if (this.props.disabled === true) {
            this.element.querySelectorAll("input, textarea, button:not(.btn-cancel, .close)").forEach(e => {
                (e as any).disabled = true;
            });
        } 

        if (this.props.zIndex) {
            this.element.style.zIndex = this.props.zIndex.toString();
        }

        if (this.props.height) {
            let frame = this.element.querySelector(".popup-frame") as HTMLElement;
            if (frame) {
                frame.style.maxHeight = this.props.height;
            }
        }

        return this.element;
    }

    private onSave = (event: Event) => {

        // Call save handler
        if (this.props.onSave) {
            if (this.props.onSave(event)) {
                app.destroyDomElements(this.element);
                if (this.props.onClosed) {
                    this.props.onClosed();
                }
            }
        } else {
            app.destroyDomElements(this.element);
            if (this.props.onClosed) {
                this.props.onClosed();
            }
        }
    }

    private onDelete = (event: Event): void => {
        // Call delete handler
        if (this.props.onDelete) {
            if (this.props.onDelete(event)) {
                app.destroyDomElements(this.element);
                if (this.props.onClosed) {
                    this.props.onClosed();
                }
            }
        } else {
            app.destroyDomElements(this.element);
            if (this.props.onClosed) {
                this.props.onClosed();
            }
        }
    }

    private onClose = (event: Event): void => {
        if (this.props.onClose)
            this.props.onClose();

        app.destroyDomElements(this.element);

        if (this.props.onClosed) {
            this.props.onClosed();
        }
    }

    private onCancel = (event: Event): void => {
        if (this.props.onCancel) {
            this.props.onCancel(event);
        }

        app.destroyDomElements(this.element);

        if (this.props.onClosed) {
            this.props.onClosed();
        }
    }

    private onOk = (event: Event): void => {
        if (this.props.onOk) {
            this.props.onOk(event);
        }

        app.destroyDomElements(this.element);

        if (this.props.onClosed) {
            this.props.onClosed();
        }
    }

    /** Static quick helper for very simple dialogs wihtout any functionality. */
    public static ShowDialog(message: string, onOk?: (event: Event) => void) {
        document.body.appendChild(
            <DynPopup size="dialog" showOkButton={true}
                title={Resources.Common.information}
                onOk={onOk}
                zIndex={20000}>
                {message}
            </DynPopup>
        );
    }

    public static confirm = (message: string, onOk?: (event: Event) => void, onCancel?: (event: Event) => void) => {
        document.body.appendChild(
            <DynPopup size="dialog"
                showOkButton={true}
                labelOkButton={Resources.Common.yes}
                showCancelButton={true}
                labelCancelButton={Resources.Common.no}
                title={Resources.Common.confirm}
                onOk={onOk}
                onCancel={onCancel}>
                {message}
            </DynPopup>
        );
    }

    public closeDialog = () => {
        if (this.props.onClose)
            this.props.onClose();

        app.destroyDomElements(this.element);

        if (this.props.onClosed) {
            this.props.onClosed();
        }
    }
}